// Feature Super Admin: consulta dos dados do boleto direto no banco emissor.
// GET `${BASE_URL}/admin/boleto/{paymentTransactionId}/bank-data` (gateway),
// que faz proxy para o payment. Espelha o padrão de src/services/admin/reprocess.ts.
import { api } from "@/api"
import { BASE_URL, ENDPOINTS } from "@/constants"
import { useQuery } from "@/libs"
import type { BankSlipBankDataResponse } from "@/types/bank-slip-bank-data"

// Chave base das queries da feature (id da transação como discriminante).
export const BANK_SLIP_BANK_DATA_QUERY_KEY =
  ENDPOINTS.ADMIN_BOLETO

// Busca os dados do boleto no banco para a transação informada.
export const getBankSlipBankData = async (
  paymentTransactionId: string
): Promise<BankSlipBankDataResponse> => {
  const url = `${BASE_URL}${ENDPOINTS.ADMIN_BOLETO}/${paymentTransactionId}/bank-data`
  const { data } =
    await api.get<BankSlipBankDataResponse>(url)
  return data
}

// Opções da query (exportadas p/ teste). `enabled` só dispara a busca
// quando o dialog está aberto — evita chamada no banco a cada render.
export const bankSlipBankDataQueryOptions = (
  paymentTransactionId: string,
  enabled: boolean
) => ({
  queryKey: [
    BANK_SLIP_BANK_DATA_QUERY_KEY,
    paymentTransactionId,
  ] as const,
  queryFn: async () =>
    getBankSlipBankData(paymentTransactionId),
  enabled: enabled && Boolean(paymentTransactionId),
  // Consulta em tempo real no banco: não reaproveita cache antigo.
  staleTime: 0,
  gcTime: 0,
})

export const useBankSlipBankData = (
  paymentTransactionId: string,
  enabled: boolean
) => {
  return useQuery(
    bankSlipBankDataQueryOptions(
      paymentTransactionId,
      enabled
    )
  )
}
